function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { getNode, setNodes, insertNodes } from '@udecode/plate-common';
import { isElement, getPlatePluginWithOverrides } from '@udecode/plate-core';
import { Node, Transforms } from 'slate';
var withNormalizeTypes = function withNormalizeTypes(_ref) {
  var rules = _ref.rules,
    onError = _ref.onError;
  return function (editor) {
    var normalizeNode = editor.normalizeNode;
    editor.normalizeNode = function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        currentNode = _ref3[0],
        currentPath = _ref3[1];
      if (!currentPath.length) {
        var endCurrentNormalizationPass = rules.some(function (_ref4) {
          var strictType = _ref4.strictType,
            type = _ref4.type,
            path = _ref4.path;
          var node = getNode(editor, path);
          if (node) {
            if (strictType && isElement(node) && node.type !== strictType) {
              setNodes(editor, {
                type: strictType
              }, {
                at: path
              });
              return true;
            }
          } else {
            try {
              insertNodes(editor, {
                type: strictType !== null && strictType !== void 0 ? strictType : type,
                children: [{
                  text: ''
                }]
              }, {
                at: path
              });
              return true;
            } catch (err) {
              onError === null || onError === void 0 ? void 0 : onError(err);
            }
          }
          return false;
        });
        if (endCurrentNormalizationPass) {
          return;
        }
      }
      return normalizeNode([currentNode, currentPath]);
    };
    return editor;
  };
};
/**
 * @see {@link withNormalizeTypes}
 */

var createNormalizeTypesPlugin = getPlatePluginWithOverrides(withNormalizeTypes);

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray_1(value) ? value : [value];
}
var castArray_1 = castArray;

/**
 * Remove nodes with empty text.
 */

var withRemoveEmptyNodes = function withRemoveEmptyNodes(options) {
  return function (editor) {
    var types = castArray_1(options.type);
    var normalizeNode = editor.normalizeNode;
    editor.normalizeNode = function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        node = _ref6[0],
        path = _ref6[1];
      if (isElement(node) && node.type && types.includes(node.type) && Node.string(node) === '') {
        Transforms.removeNodes(editor, {
          at: path
        });
        return;
      }
      normalizeNode([node, path]);
    };
    return editor;
  };
};
/**
 * @see {@link withRemoveEmptyNodes}
 */

var createRemoveEmptyNodesPlugin = getPlatePluginWithOverrides(withRemoveEmptyNodes);
export { createNormalizeTypesPlugin, createRemoveEmptyNodesPlugin, withNormalizeTypes, withRemoveEmptyNodes };